import { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import Navigation from './components/Navigation'
import PreLandingPage from './pages/PreLandingPage'
import HomePage from './pages/HomePage'
import SolutionsPage from './pages/SolutionsPage'
import Contact from './pages/Contact'
import Footer from './sections/Footer'
import CustomCursor from './components/CustomCursor'
import SmoothScroll from './components/SmoothScroll'

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.25, ease: 'easeOut' } },
  exit:    { opacity: 0, transition: { duration: 0.15, ease: 'easeIn' } },
}

function App() {
  const location = useLocation()

  useEffect(() => {
    // Prevent default scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
  }, [])

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <>
      <CustomCursor />
      <SmoothScroll>
        <Navigation />
        <main id="main-content">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={location.pathname}
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <Routes location={location}>
                <Route path="/" element={<PreLandingPage />} />
                <Route path="/boxos" element={<HomePage />} />
                <Route path="/solutions" element={<SolutionsPage />} />
                <Route path="/contact" element={<><Contact /><Footer /></>} />
              </Routes>
            </motion.div>
          </AnimatePresence>
        </main>
      </SmoothScroll>
    </>
  )
}

export default App
